import React, { Component } from 'react';
import { connect } from 'react-redux';

//3 party Libs
import moment from 'moment';

//material ui components
import { Grid } from '@material-ui/core'
import { Paper } from '@material-ui/core'

//Actions
import { getCommunityByIdAsync } from '../../actions/communityActions'
import { GetAllActivities, GetActivityDetails, GetCalendarActivities, GetCategorieObject, GetMultipleCategorieObject } from '../../actions/activityAction';
import parse from 'html-react-parser';




export class SchedulerWeekView extends Component {
    constructor(props) {
        super();

        this.state = {
            startDateWeek: undefined,
            endDateWeek: undefined,
            referenceDate: new Date(),
            //Community
            communityLoaded: undefined,
            //stepCount
            stepCount: 0,
            //Activities
            baseActivities: undefined,
            Activities: undefined,
            //Filter
            filterObj: undefined,
            //Styles
            Styles: {
                cellHeight: '9',
                cellWidth: '14.2857%',
            },
            //rootFontSize
            rootFontSize: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 970,
            },
            calendarActivities: [],

        }
    };

    //Days of the Week
    Days = [
        {
            id: 0,
            name: 'SUNDAY',
            short: 'Sun',
        },
        {
            id: 1,
            name: 'MONDAY',
            short: 'Mon',
        },
        {
            id: 2,
            name: 'TUESDAY',
            short: 'Tue',
        },
        {
            id: 3,
            name: 'WEDNESDAY',
            short: 'Wed',
        },
        {
            id: 4,
            name: 'THURSDAY',
            short: 'Thu',
        },
        {
            id: 5,
            name: 'FRIDAY',
            short: 'Fri',
        },
        {
            id: 6,
            name: 'SATURDAY',
            short: 'Sat',
        },
    ]

    //Hour Activities
    Hours = [
        {
            text: '12:00 am',
            hour: 0,
            minutes: 0,
        },
        {
            text: '01:00 am',
            hour: 1,
            minutes: 0,
        },
        {
            text: '02:00 am',
            hour: 2,
            minutes: 0,
        },
        {
            text: '03:00 am',
            hour: 3,
            minutes: 0,
        },
        {
            text: '04:00 am',
            hour: 4,
            minutes: 0,
        },
        {
            text: '05:00 am',
            hour: 5,
            minutes: 0,
        },
        {
            text: '06:00 am',
            hour: 6,
            minutes: 0,
        },
        {
            text: '07:00 am',
            hour: 7,
            minutes: 0,
        },
        {
            text: '08:00 am',
            hour: 8,
            minutes: 0,
        },
        {
            text: '09:00 am',
            hour: 9,
            minutes: 0,
        },
        {
            text: '10:00 am',
            hour: 10,
            minutes: 0,
        },
        {
            text: '11:00 am',
            hour: 11,
            minutes: 0,
        },
        {
            text: '12:00 pm',
            hour: 12,
            minutes: 0,
        },
        {
            text: '01:00 pm',
            hour: 13,
            minutes: 0,
        },
        {
            text: '02:00 pm',
            hour: 14,
            minutes: 0,
        },
        {
            text: '03:00 pm',
            hour: 15,
            minutes: 0,
        },
        {
            text: '04:00 pm',
            hour: 16,
            minutes: 0,
        },
        {
            text: '05:00 pm',
            hour: 17,
            minutes: 0,
        },
        {
            text: '06:00 pm',
            hour: 18,
            minutes: 0,
        },
        {
            text: '07:00 pm',
            hour: 19,
            minutes: 0,
        },
        {
            text: '08:00 pm',
            hour: 20,
            minutes: 0,
        },
        {
            text: '09:00 pm',
            hour: 21,
            minutes: 0,
        },
        {
            text: '10:00 pm',
            hour: 22,
            minutes: 0,
        },
        {
            text: '11:00 pm',
            hour: 23,
            minutes: 0,
        },

    ]

    componentDidMount() {

        window.addEventListener("resize", this.resize.bind(this));
        this.resize();

        this.GetStartAndEndofTheWeek();

    }

    GetHTMLFromString = ({ str = undefined, styleObjString = undefined }) => {
        try {
            let newStr = str;
            if (styleObjString && styleObjString.length > 0) {
                newStr = this.ChangeStrStyle(str, styleObjString);
            }

            if (!newStr) return (<Grid item container></Grid>)

            return (
                <Grid item container>
                    {parse(newStr)}
                </Grid>
            )
        } catch (err) {
            return (<Grid item container></Grid>)
        }
    }


    ChangeStrStyle = (str, styleObj) => {
        try {
            let strModified = str;
            const styleObjAsString = `<svg ${styleObj} `

            if (styleObj) {
                strModified = str.replace('<svg', styleObjAsString);
            }

            return strModified
        } catch (err) {
            return str;
        }
    }

    resize() {
        const sizes = {
            xs: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 970,
            },
            sm: {
                name: 'sm',
                fontSize: '60%',
                maxWidht: 1024,
            },
            md: {
                name: 'md',
                fontSize: '80%',
                maxWidht: 1880,
            },
            lg: {
                name: 'lg',
                fontSize: '100%',
                maxWidht: 1920,
            },
        };

        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;

        let rootFontSize = sizes.xs;

        if (windowWidth > sizes.md.maxWidht) {
            rootFontSize = sizes.lg;
        } else if (windowWidth > sizes.sm.maxWidht) {
            rootFontSize = sizes.md;
        } else if (windowWidth > sizes.xs.maxWidht) {
            rootFontSize = sizes.sm;
        } else {
            rootFontSize = sizes.xs;
        }





        this.setState({
            rootFontSize: rootFontSize,
            windowWidth: windowWidth,
            windowHeight: windowHeight,
        });
    };


    filterActivities = (activities, filterObject) => {

        const baseActivities = [...activities];
        let newActivities = undefined;
        newActivities = baseActivities;

        //Activity Search
        if (filterObject.searchInput) {
            const regex = new RegExp(filterObject.searchInput.toLowerCase());
            newActivities = newActivities.filter(item => item.title.toLowerCase().match(regex));
        }

        if (filterObject) {
            //Activities Filter
            if (filterObject.activityFilter) {
                newActivities = newActivities.filter(item => item.title.trim() === filterObject.activityFilter.trim());
            }

            //Category Filter


            if (filterObject.categoryFilter) {

                newActivities = newActivities.filter(item => item.category.name.trim() === filterObject.categoryFilter.trim());
            }
        }

        this.setState({
            Activities: newActivities
        });
    };



    async GetActivities() {
        const communityId = localStorage.getItem('communityId') ? localStorage.getItem('communityId') : undefined;

        let activities = await this.props.GetCalendarActivities(communityId);

        activities = this.props.activitiesData.map(item => ({
            ...item,
            date: new Date(new Date(item.date).toLocaleString("en-US", { timeZone: this.props.communitySelected.timeZoneName })),
            endDate: new Date(new Date(item.endDate).toLocaleString("en-US", { timeZone: this.props.communitySelected.timeZoneName })),
        }));//End map


        this.SearchActivitiesThatOverlap(activities);

        let activityNamesToFilter = [...new Set(activities.map(item => item.title))];
        if (activityNamesToFilter) {
            activityNamesToFilter = activityNamesToFilter.map((item, index) => ({ id: index + 1, name: item }))
        }

        // if(this.props.onFilter && activityNamesToFilter){
        //     const newFilterObj = this.props.filterObj? {...this.props.filterObj}: {}; 
        //     newFilterObj.activitiesData = activityNamesToFilter;

        //     this.props.onFilter(newFilterObj?newFilterObj : {})
        // }

        this.setState({ calendarActivities: activities })
        return activities;
    };

    //GET Start and End of the Week
    GetStartAndEndofTheWeek = async () => {

        let startDateWeek = moment(this.state.referenceDate).startOf('week');
        let endDateWeek = moment(this.state.referenceDate).endOf('week');

        if (this.props.stepCount > 0) {
            startDateWeek = startDateWeek.add(this.props.stepCount, 'weeks');
            endDateWeek = endDateWeek.add(this.props.stepCount, 'weeks');

        } else if (this.props.stepCount < 0) {
            startDateWeek = startDateWeek.subtract(-1 * this.props.stepCount, 'weeks');
            endDateWeek = endDateWeek.subtract(-1 * this.props.stepCount, 'weeks');
        }

        const KeysInfo = await this.GetKeysDates();

        const startDateCategoryCodes = (KeysInfo.startDateCategoryCodes) ? KeysInfo.startDateCategoryCodes : undefined;
        const startDateLocationCodes = (KeysInfo.startDateLocationCodes) ? KeysInfo.startDateLocationCodes : undefined;
        const daysNeddedForCategoryCodes = (KeysInfo.daysNeddedForCategoryCodes) ? KeysInfo.daysNeddedForCategoryCodes : 1;
        const daysNeddedForLocationCodes = (KeysInfo.daysNeddedForLocationCodes) ? KeysInfo.daysNeddedForLocationCodes : 1;
        const categoriesUniqueArray = (KeysInfo.categoriesUniqueArray) ? KeysInfo.categoriesUniqueArray : undefined;
        const locationsUniqueArray = (KeysInfo.locationsUniqueArray) ? KeysInfo.locationsUniqueArray : undefined;

        this.setState({
            startDateWeek: (startDateWeek) ? startDateWeek : undefined,
            endDateWeek: (endDateWeek) ? endDateWeek : undefined,
            startDateCategoryCodes: startDateCategoryCodes,
            startDateLocationCodes: startDateLocationCodes,
            daysNeddedForCategoryCodes: daysNeddedForCategoryCodes,
            daysNeddedForLocationCodes: daysNeddedForLocationCodes,
            categoriesUniqueArray: categoriesUniqueArray,
            locationsUniqueArray: locationsUniqueArray,
        });

    };

    GetKeysDates = async () => {
        try {
            //Calculate initial cell for category code cells
            let startOfCurrentMonth = new moment(this.state.referenceDate).clone().startOf('Weeks')
            let endOfCurrentMonth = new moment(this.state.referenceDate).clone().endOf('Weeks')

            if (this.props.stepCount > 0) {
                startOfCurrentMonth = startOfCurrentMonth.add(this.props.stepCount, 'Weeks');
                endOfCurrentMonth = endOfCurrentMonth.add(this.props.stepCount, 'Weeks');

            } else if (this.props.stepCount < 0) {
                startOfCurrentMonth = startOfCurrentMonth.subtract(-1 * this.props.stepCount, 'Weeks');
                endOfCurrentMonth = endOfCurrentMonth.subtract(-1 * this.props.stepCount, 'Weeks');
            }

            const startDayNumberOfMonth = startOfCurrentMonth.day();
            const endDayNumberOfMonth = endOfCurrentMonth.day();

            let startDateCategoryCodes = undefined;
            let startDateLocationCodes = undefined;
            let categoriesArray = [];
            let locationsArray = [];

            let daysNeddedForCategoryCodes = 2;
            let daysNeddedForLocationCodes = 2;
            let activitiesData = this.props.activitiesData;
            activitiesData = activitiesData.filter(act => (new moment(act.date) >= startOfCurrentMonth && new moment(act.date) <= endOfCurrentMonth) ? true : false);

            if (activitiesData && activitiesData.length > 0) {
                let categoriesInfo = activitiesData.map(act => {
                    if (act && act.category) {
                        const category = act.category
                        return { name: category.name, iconUrl: category.iconUrl, categoryColor: category.categoryColor, categoryId: category.categoryId, }
                    } else {
                        return undefined;
                    }
                });
                categoriesInfo = categoriesInfo.filter(cat => (cat.name) ? 1 : -1);
                let uniqueCatArray = [...new Set(categoriesInfo.map(cat => (cat.name)))];
                uniqueCatArray = uniqueCatArray.sort((a, b) => a.toUpperCase() > b.toUpperCase());
                let uniquecategoryObjArray = [];
                for (let i = 0; i < uniqueCatArray.length; i++) {
                    const currentCatString = uniqueCatArray[i];
                    const categoryObj = categoriesInfo.find(cat => cat.name === currentCatString);

                    if (categoryObj) {
                        uniquecategoryObjArray.push(categoryObj);
                    }
                }

                // for(let i =0; i< uniquecategoryObjArray.length; i++){
                //     const currentCategorieObj = uniquecategoryObjArray[i];

                //     if(!currentCategorieObj || !currentCategorieObj.iconUrl || !currentCategorieObj.categoryColor || !currentCategorieObj.categoryId|| !this.props.GetCategorieObject) continue

                //     const catIconSVGObject = await this.props.GetCategorieObject(currentCategorieObj.iconUrl, currentCategorieObj.categoryColor, currentCategorieObj.categoryId);

                //     currentCategorieObj.svgString = (catIconSVGObject)? catIconSVGObject : undefined;
                // }

                /////
                let urlObjArray = [];
                const communityId = localStorage.getItem('communityId') ? localStorage.getItem('communityId') : undefined;
                for (let i = 0; i < uniquecategoryObjArray.length; i++) {
                    const currentCategorieObj = uniquecategoryObjArray[i];
                    const newUrlObj = {
                        communityId: communityId,
                        categoryId: currentCategorieObj.categoryId,
                        categoryColor: currentCategorieObj.categoryColor,
                        defaultIconUrl: currentCategorieObj.iconUrl,
                    }

                    urlObjArray.push(newUrlObj);
                }

                let newUrlsArray = undefined;
                if (urlObjArray && urlObjArray.length > 0) {
                    newUrlsArray = await this.props.GetMultipleCategorieObject(urlObjArray)
                }

                let newUrlsObjArray = [];
                if (newUrlsArray && newUrlsArray.length > 0) {
                    newUrlsObjArray = JSON.parse(newUrlsArray);
                }

                for (let i = 0; i < newUrlsObjArray.length; i++) {
                    const currentObj = newUrlsObjArray[i];


                    const uniqueCategory = uniquecategoryObjArray.find(cat => cat.categoryId === currentObj.categoryId && !cat.svgString);

                    if (uniqueCategory && currentObj.svgObject) {
                        uniqueCategory.svgString = currentObj.svgObject;
                    }
                }
                /////


                categoriesArray = uniquecategoryObjArray;

                daysNeddedForCategoryCodes = uniquecategoryObjArray.length <= 6 ? 1 : 2;

                let locationsInfo = activitiesData.map(act => act.location);
                let uniqueLocationArray = [...new Set(locationsInfo)];
                uniqueLocationArray = uniqueLocationArray.sort();

                let LocationObjArray = [];
                for (let i = 0; i < uniqueLocationArray.length; i++) {
                    let currentLocation = uniqueLocationArray[i];

                    let locationSplitArray = currentLocation.split(/[\s+]/);

                    //Starts with number
                    const regexNumber = new RegExp('^[0-9]+');

                    const res = regexNumber.test(locationSplitArray[0]);

                    let locationCode = undefined;

                    if (locationSplitArray[0] && locationSplitArray[0].length > 0 && res) {
                        let letterArray = locationSplitArray[0].split('');
                        letterArray = letterArray.filter(l => regexNumber.test(l)).join('');
                        locationCode = (letterArray && letterArray.length > 1) ? letterArray.slice(0, 2) : letterArray;

                    } else {
                        let locationFiltered = locationSplitArray.filter(l => (l !== '&' && l !== '&&') ? true : false)
                        locationFiltered = locationFiltered.map(l => l.slice(0, 1))

                        locationCode = (locationSplitArray && locationSplitArray.length === 1) ? locationFiltered[0] : locationFiltered[0] + locationFiltered[1]
                        const LocationObjFound = LocationObjArray.find(l => l.code.toUpperCase() === locationCode.toUpperCase());

                        if (LocationObjFound) {
                            let newCode = currentLocation.split('\\s+');
                            newCode = newCode.filter(l => (l !== '&' && l !== '&&'))
                            locationCode = newCode.map(w => {
                                let code = undefined;
                                if (w && w.length > 1) {
                                    code = w.slice(0, 2);
                                } else {
                                    code = w[0]
                                }

                                return code
                            }
                            ).join('').slice(0, 2);
                        }
                    }

                    const newLocation = {
                        code: locationCode,
                        name: currentLocation,
                    }
                    LocationObjArray.push(newLocation);
                }

                locationsArray = LocationObjArray;

                daysNeddedForLocationCodes = uniqueLocationArray.length <= 6 ? 1 : 2;
            }

            if ((startDayNumberOfMonth + 1) >= (daysNeddedForCategoryCodes + daysNeddedForLocationCodes)) {
                //Both on start
                startDateCategoryCodes = startOfCurrentMonth.clone().startOf('Week');
                startDateLocationCodes = startOfCurrentMonth.clone().startOf('Week').add(daysNeddedForCategoryCodes, 'd');
            } else if ((startDayNumberOfMonth + 1) > daysNeddedForCategoryCodes) {
                //Just  category on start and location on end
                startDateCategoryCodes = startOfCurrentMonth.clone().startOf('Week');
                startDateLocationCodes = startOfCurrentMonth.clone().endOf('Month').endOf('Week').startOf('Day').subtract(daysNeddedForLocationCodes, 'd');
            } else if (7 - (endDayNumberOfMonth + 1) > (daysNeddedForCategoryCodes + daysNeddedForLocationCodes)) {
                //Both on end
                startDateCategoryCodes = startOfCurrentMonth.clone().endOf('Month').endOf('Week').startOf('Day').subtract((daysNeddedForLocationCodes), 'd');//
                startDateLocationCodes = startOfCurrentMonth.clone().endOf('Month').endOf('Week').startOf('Day').subtract((daysNeddedForLocationCodes) - 1, 'd');
            } else if (7 - (endDayNumberOfMonth + 1) > daysNeddedForLocationCodes) {
                //Just Location on End
                startDateLocationCodes = startOfCurrentMonth.clone().endOf('Month').endOf('Week').startOf('Day').subtract(daysNeddedForLocationCodes - 1, 'd');
            }

            return {
                startDateCategoryCodes: startDateCategoryCodes,
                startDateLocationCodes: startDateLocationCodes,
                daysNeddedForCategoryCodes: daysNeddedForCategoryCodes,
                daysNeddedForLocationCodes: daysNeddedForLocationCodes,
                categoriesUniqueArray: categoriesArray,
                locationsUniqueArray: locationsArray,
            }
        } catch (err) {
        }
    }

    async LoadCommunity() {
        const communityId = localStorage.getItem('communityId') ? localStorage.getItem('communityId') : undefined;

        if (communityId) {
            const community = await this.props.getCommunityByIdAsync(communityId);

            if (community && community.length > 0) {
                this.setState({ communityLoaded: community[0] });
            }
        }
    };

    SearchActivitiesThatOverlap(arrayActivities) {
        const activities = arrayActivities.map(
            activity => { // 1.3

                const cStartDate = activity.date; // 5 35
                const cEndDate = activity.endDate; // 630

                let index = -1;
                const overlapingActivities = [];

                arrayActivities.forEach(
                    sActivity => {
                        if (sActivity.date < cEndDate && sActivity.endDate > cStartDate) {

                            index = index + 1;
                            overlapingActivities.push(
                                {
                                    index: index,
                                    _id: sActivity._id,
                                    title: sActivity.title,
                                }
                            )
                        }
                    }
                )// close foreach

                let activityleft = overlapingActivities.find(item => item._id === activity._id);
                activityleft = activityleft ? activityleft.index : 0;

                activity.overlapping = {
                    overlappingActivities: overlapingActivities,
                    width: 100 / overlapingActivities.length,
                    left: (100 / overlapingActivities.length) * activityleft,
                }
                return activity

            }); // close initial map


        activities.map(
            act => {
                let newOverlappingActivities = act.overlapping.overlappingActivities;
                const activitiesOverlapping = act.overlapping.overlappingActivities.map(item => item._id);

                activities.forEach(
                    sAct => {
                        const indexActivity = activitiesOverlapping.findIndex(item => item === sAct._id);
                        if (indexActivity !== -1) {
                            if (sAct.overlapping.overlappingActivities.length > activitiesOverlapping.length) {
                                newOverlappingActivities = sAct.overlapping.overlappingActivities
                            }
                        }
                    });

                let activityleft = newOverlappingActivities.find(item => item._id === act._id);
                activityleft = activityleft ? activityleft.index : 0;

                act.overlapping = {
                    overlappingActivities: newOverlappingActivities,
                    width: 100 / newOverlappingActivities.length,
                    left: (100 / newOverlappingActivities.length) * activityleft,
                }

                return act
            }



        );//End map

        this.setState({ Activities: activities, baseActivities: activities })
    };

    SearchActivitiesinGivenTime = (startTime, date) => {

        const dateOfstart = new Date(date.year(), date.month(), date.date(), startTime, 0);

        const sStartTime = moment(dateOfstart)
        const eStartTime = moment(dateOfstart).add(1, 'hours');

        const activities = this.state.Activities.filter(item => (item.date >= sStartTime && item.date < eStartTime));

        return activities;
    };

    GetCategoryBadge(categoryName) {
        let categoryWords = categoryName.split(' ');

        categoryWords = categoryWords.filter(item => item !== '&');

        const CategoryBadge = categoryWords.map(word => word.charAt(0).toUpperCase()).join('').slice(0, 2);

        return CategoryBadge;
    };

    async GetActivityObject(locationActivityId) {


        this.setState({ activitySelected: null })

        const activityObject = await this.props.GetActivityDetails(locationActivityId, localStorage.getItem('communityId'));


        if (activityObject) {
            this.props.OnActivityClick(activityObject, 'activity_' + locationActivityId)
            //this.props.history.push({pathname:'/activities', state: activityObject})
        }
    };

    GetActivitiSpan(startHour = 6, date) {

        //date is a moment object
        const activities = this.SearchActivitiesinGivenTime(startHour, date);

        let badgeWidth = (this.state.rootFontSize.name === 'xs' || this.state.rootFontSize.name === 'sm') ? '12px' : '22px';
        let badgeHeight = badgeWidth;
        let fontSize = 10;

        const screenSize = this.state.rootFontSize ? this.state.rootFontSize.name : 'xs';

        switch (screenSize) {
            case 'xs':
                badgeWidth = 12;
                fontSize = 10;
                break;
            case 'sm':
                badgeWidth = 12;
                fontSize = 10
                break;
            case 'md':
                badgeWidth = 20;
                fontSize = 12;
                break;
            case 'lg':
                badgeWidth = 25;
                fontSize = 18;
                break;
            default:
                badgeWidth = 12;
                fontSize = 10
                break;
        }
        badgeHeight = badgeWidth;

        const activitiesGrids = activities.map(item => {

            item.category = (!item.category) ? {
                name: 'Special Events',
                categoryColor: '#128055',
                iconUrl: "https://engage360.s3.amazonaws.com/Icons/Categories/sparkles.svg"
            } : item.category;

            const duration = this.GetDiff(item.date, item.endDate)
            const stratMinutes = item.date.getMinutes();
            const color = item.category.categoryColor;
            const top = ((stratMinutes * 100) / 60)
            const height = ((duration * 100) / 60)
            const width = item.overlapping.width;
            const left = item.overlapping.left;


            const widthInPixels = ((window.innerWidth / 14.2)) / (100 / width)

            const styles = {
                title: {
                    fontSize: fontSize + 'px',
                    display: 'inline-block',
                    wordWrap: 'break-word',
                    maxHeight: height,
                    overflowY: 'hidden',
                    textAlign: 'left',
                    hyphens: 'auto',
                },
                styleBadge: {
                    backgroundColor: color,
                    color: 'white',
                    width: width < 20 ? widthInPixels + 'px' : badgeWidth + 'px',
                    height: width < 20 ? widthInPixels + 'px' : badgeHeight + 'px',
                    textAlign: 'center',
                    verticalAlign: 'center',
                    fontSize: width < 20 ? (widthInPixels * .6) + 'px' : (fontSize * .8) + 'px',
                    borderRadius: '50%',
                },
                style: {
                    position: 'absolute',
                    zIndex: 1,
                    borderRadius: '18px',
                    opacity: '0.7',
                    cursor: 'pointer',
                    color: 'white',
                    backgroundColor: color,
                    left: left + '%',
                    top: top + '%',
                    height: height + '%',
                    width: width + '%',
                    overflow: 'hide'
                },
            }
            const initialsFontSise = width < 20 ? (widthInPixels * .6) + 'px' : (fontSize * .8) + 'px';

            const characterLimitOnActivity = width > 50 ? 15 : 8;
            const needsToolTip = item.title ? item.title.length > characterLimitOnActivity : false;
            const newTitle = needsToolTip ? item.title.slice(0, characterLimitOnActivity - 3) + '...' : item.title;

            return (
                <Grid container key={'activity_' + item._id} className='tooltip' style={{ height: '100%', width: '99%', position: 'absolute', top: 0, left: 0 }} alignItems='center'>
                    <Grid item container xs={12} style={{ ...styles.style }}>
                        {
                            height >= 15 ?
                                <Grid item container id={'activity_' + item._id} xs={12} justify='flex-start' alignItems='center' onClick={() => this.GetActivityObject(item._id)} >
                                    {
                                        width > 8 ?
                                            <Grid item container xs={width < 50 ? 12 : 4} justify='center' alignItems='center' >
                                                <Paper id='paperBadgeWeekView' square={true} elevation={2} className={'borderRadiusFifty'} justify='center' style={{ ...styles.styleBadge, }}>
                                                    <Grid item container justify='center' alignItems='center' style={{ ...styles.styleBadge, }}>
                                                        <Grid item container justify='center' alignItems='center' style={{ fontSize: initialsFontSise }} >
                                                            {this.GetCategoryBadge(item.category.name)}
                                                        </Grid>
                                                    </Grid>
                                                </Paper>
                                            </Grid>
                                            :
                                            undefined
                                    }
                                    {
                                        width >= 50 ?
                                            <Grid item container xs={8} style={{ ...styles.title, }} >
                                                {newTitle}
                                            </Grid>
                                            :
                                            undefined
                                    }
                                </Grid>
                                :
                                undefined
                        }
                    </Grid>
                </Grid>
            );
        });



        return (
            <Grid item container xs={12} alignItems='center' style={{ position: 'relative' }}>
                {activitiesGrids}
            </Grid>
        )
    };

    GetDiff = (date1, date2) => {
        return Math.abs(Math.round(((date1.getTime() - date2.getTime()) / 1000) / 60))
    };



    render() {

        if (this.props.updateIsNeeded) {
            this.GetActivities();
            this.props.setUpdateIsNeeded(false);
        }

        if ((this.props.filterObj !== this.state.filterObj) && (this.state.calendarActivities && this.state.calendarActivities.length >0)) {
            this.setState({ filterObj: this.props.filterObj ? this.props.filterObj : {} },
                () =>{
                    this.filterActivities(this.state.calendarActivities, this.props.filterObj);     
                });
            // this.filterActivities(this.state.baseActivities, this.props.filterObj);
        }

        //#region  style Object
        const Styles = {
            scheduler: {
                marginTop: '2em',
            },
            dayHeaders: {
                backgroundColor: '#959494',
            },
            banner: {
                paddingRight: '15px',
                paddingLeft: '15px'
            },

            subtitle: {
                textAlign: 'center',
                color: 'white',
                width: '14.2857%',
            },
            cell: {

                height: this.state.Styles.cellHeight + 'rem',
                width: this.state.Styles.cellWidth,
            },
            cellPH: {
                borderTop: '1px dashed  white',
                borderBottom: '1px dashed  white',
                borderRight: '1px solid  white',
                zIndex: '2000px',
                height: this.state.Styles.cellHeight + 'rem',
                width: this.state.Styles.cellWidth,
            },
            lastRowCell: {
                borderTop: '1px dashed  white',
                borderRight: '1px solid  white',
                height: this.state.Styles.cellHeight + 'rem',
                width: this.state.Styles.cellWidth,
            },
            timeMark: {
                color: 'white',
                fontSize: '1rem'
            },
            dateRow: {
                color: '#009EDD',
                fontSize: '2rem',
                textAlign: 'right',
                verticalAlign: 'bottom'
            },

        }
        //#endregion

        if (this.props.communitySelected !== this.state.communityLoaded) {
            this.setState({ communityLoaded: this.props.communitySelected, Activities: undefined })
            this.GetActivities();
        }

        if (this.props.stepCount !== this.state.stepCount) {
            this.setState({ stepCount: this.props.stepCount })

            this.GetStartAndEndofTheWeek();
        }


        //#region  Inner Components
        const RenderHeader = () => {
            try {
                const SameMonth = (this.state.startDateWeek && this.state.endDateWeek) ?
                    <div className='WeekViewDate'>
                        <grid className='WeekViewDateStrong'>{this.state.startDateWeek.format('MMMM')}</grid>
                        {
                            " " +
                            this.state.startDateWeek.clone().format('D') +
                            " - " +
                            this.state.endDateWeek.clone().format('D') +
                            ", " +
                            this.state.endDateWeek.clone().format('YYYY')
                        }
                    </div>
                    :
                    undefined;

                const DifferentMonth = (this.state.startDateWeek && this.state.endDateWeek) ?
                    <div className='WeekViewDate'>
                        <grid className='WeekViewDateStrong'>{this.state.startDateWeek.format('MMMM')}</grid>
                        {
                            " " +
                            this.state.startDateWeek.clone().format('D') +
                            " - "
                        }
                        <grid className='WeekViewDateStrong'>{this.state.endDateWeek.format('MMMM')}</grid>
                        {
                            " " +
                            this.state.endDateWeek.clone().format('D') +
                            ", " +
                            this.state.startDateWeek.clone().format('YYYY')
                        }
                    </div>
                    :
                    undefined;

                //className='MonthViewHeader'
                return (
                    <Grid item container xs={12} className='WeekViewHeader' >
                        <Grid item container alignItems='center' justify='flex-start' xs={8}>
                            {(this.state.startDateWeek && this.state.endDateWeek) ?
                                (this.state.startDateWeek.format('MMMM') === this.state.endDateWeek.format('MMMM')) ?
                                    SameMonth
                                    :
                                    DifferentMonth
                                :
                                undefined
                            }
                        </Grid>
                        <Grid item container alignContent='center' justify='flex-end' xs={4} >
                            <Grid item className='WeekViewCommuntyImg'>
                                {/* {this.state.communityLoaded ? this.state.communityLoaded.name : undefined} */}
                                {
                                    (this.state.communityLoaded && this.state.communityLoaded.communityLogoUrl) ?
                                        <img
                                            className='WeekViewCommuntyImg'
                                            src={this.state.communityLoaded.communityLogoUrl}
                                            alt={this.state.communityLoaded.name}
                                        />
                                        :
                                        undefined
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                )
            } catch (err) { }
        };

        const RenderDaysHeader = () => {
            return (
                <Grid item id='DaysHeader' container alignContent='center' className='WeekViewDaysHeader' xs={12} justify='space-around' direction='row' >
                    {
                        this.Days ?
                            this.Days.map(
                                day => {

                                    return (
                                        <Grid item key={day.id} style={{ ...Styles.subtitle }}>
                                            {
                                                day.name
                                            }
                                        </Grid>
                                    )
                                })
                            :
                            undefined
                    }
                </Grid>
            )
        };

        const RenderDateRow = () => {
            const daysToAdd = [0, 1, 2, 3, 4, 5, 6];

            return (
                <Grid item container xs={12} justify='space-around' direction='row' >
                    {
                        this.state.startDateWeek ?
                            <Grid item container xs={12} direction='row'>
                                {
                                    (daysToAdd) ?
                                        daysToAdd.map(
                                            day => <RenderDateCell key={'DayToAdd' + day} daysToAdd={day} />
                                        )
                                        :
                                        undefined
                                }
                            </Grid>
                            :
                            undefined
                    }

                </Grid>

            )
        };

        const RenderDateCell = ({ daysToAdd }) => {

            return (
                <Grid item container className='WeekViewDateCell' justify='flex-end' alignContent='flex-start'>
                    <Grid item>
                        {this.state.startDateWeek.clone().add(daysToAdd, 'days').format('D')}
                    </Grid>
                </Grid>
            );
        };

        const RenderKeysComponentes = ({ activitiesData, startDate, endDate }) => {
            const weekDays = [0, 1, 2, 3, 4, 5, 6]

            return (
                <Grid item container xs={12} className='oddRow WeekViewKeysRow' >
                    {
                        (weekDays && weekDays.length > 0) ?
                            weekDays.map(
                                d => {
                                    return (
                                        <KeyCell day={d} />
                                    )
                                }
                            )
                            :
                            undefined
                    }
                </Grid>
            )
        }

        const KeyCell = ({ day }) => {
            const styles = {
                cell: {
                    width: (100 / 7) + '%',
                    border: '1px solid #009EDD',
                }
            }

            if (!this.state.daysNeddedForCategoryCodes || !this.state.daysNeddedForLocationCodes || !this.state.categoriesUniqueArray || !this.state.locationsUniqueArray) return (<Grid item container ></Grid>)

            return (
                <Grid item container style={{ ...styles.cell }}>
                    {
                        (day === 0 || day === 1) ?
                            <RenderCategoriesKeysComponent day={day} />
                            :
                            undefined
                    }
                    {
                        (day === 5 || day === 6) ?
                            <RenderLocationsKeysComponent day={day} />
                            :
                            undefined
                    }
                </Grid>
            )
        }



        const RenderActivitiesColumComponent = ({ startDate, endDate, activitiesData }) => {

            try {
                const weekDaysArray = [0, 1, 2, 3, 4, 5, 6];

                const activitiesForThisWeek = (activitiesData && startDate && endDate) ?
                    activitiesData.filter(act => (new moment(act.date) >= new moment(startDate) && new moment(act.date) <= new moment(endDate)) ? true : false)
                    :
                    undefined;

                return (
                    <Grid item container>
                        {
                            (weekDaysArray) ?
                                weekDaysArray.map(day => {
                                    const todayStart = new moment(startDate).add(day, 'd').startOf('d');
                                    const todayEnd = new moment(startDate).add(day, 'd').endOf('d');

                                    const activitiesForToday = (activitiesForThisWeek && todayStart && todayEnd) ? activitiesForThisWeek.filter(act => (new moment(act.date) >= new moment(todayStart) && new moment(act.date) <= new moment(todayEnd)) ? true : false) : undefined;

                                    return (
                                        RenderSingleActivitiesColumns(activitiesForToday)
                                    )
                                }
                                )
                                :
                                undefined
                        }
                    </Grid>
                )
            } catch (err) { }

        }

        const RenderSingleActivitiesColumns = (activitiesForToday) => {

            if (!activitiesForToday) return (<Grid item container></Grid>)

            const newActivitiesForToday = (activitiesForToday && activitiesForToday.length > 10) ? activitiesForToday.slice(0, 10) : activitiesForToday;


            return (
                <Grid item container className='WeekViewActivitiesColumn' justify='center' alignContent='flex-start'>
                    {
                        (newActivitiesForToday && newActivitiesForToday.length > 0) ?
                            newActivitiesForToday.map(
                                (act, index) => <RenderSingleActivity activity={act} index={index} />
                            )
                            :
                            undefined
                    }
                </Grid>
            )
        }

        const RenderSingleActivity = ({ activity, index }) => {

            try {

                if (!activity) return (<Grid item container ></Grid>)

                let isSpecialActivity = (activity && activity.category && activity.category.name && (activity.category.name.toLowerCase() === 'special events' || activity.category.name.toLowerCase() === 'special event'))

                let locationFound = (activity && activity.location && this.state.locationsUniqueArray && this.state.locationsUniqueArray.length > 0) ?
                    this.state.locationsUniqueArray.find(l => (l.name.toLowerCase() === activity.location.toLowerCase()))
                    :
                    undefined;
                locationFound = (locationFound && locationFound.code) ? locationFound.code : undefined;

                let activityName = (activity && activity.title && activity.title.length > 25) ? activity.title.slice(0, 25).trim() + '...' : activity.title.trim();
                activityName = activityName + ` (${locationFound})`

                const catFound = (this.state.categoriesUniqueArray) ? this.state.categoriesUniqueArray.find(cat => cat.name === activity.category.name) : undefined;

                const paddingTop = (index === 0) ? '0px' : '14px';
                return (
                    <Grid item container style={{ paddingTop: paddingTop }}>
                        <Grid item container justify='center' alignContent='flex-start' className={isSpecialActivity ? 'WeeklyViewActivity activityTitleScheduleSpecialEvent' : 'WeeklyViewActivity'} id={'activity_' + activity._id} key={'activity_' + activity._id} onClick={() => this.GetActivityObject(activity._id)}>
                            <Grid item container justify='center' alignContent='flex-start' style={{ paddingRight: '5px', width: '38%' }}>
                                <Grid item container xs={12} className={isSpecialActivity ? 'WeeklyViewActivityTime activityTitleScheduleSpecialEvent' : 'WeeklyViewActivityTime'} justify='flex-end' alignContent='flex-start'>
                                    <Grid item  >
                                        {(activity.date) ? new moment(activity.date).format('h:mm') : undefined}
                                    </Grid>
                                </Grid>
                                <Grid item container xs={12} className='WeeklyViewActivityCategoryIcon' justify='center' alignContent='flex-start'>
                                    {
                                        (catFound && catFound.svgString) ?
                                            <Grid item style={{ height: '13px', width: '13px' }} >
                                                <this.GetHTMLFromString str={catFound.svgString} styleObjString={"style='height: 13px; width: 13px;'"} />
                                            </Grid>
                                            :
                                            undefined

                                    }
                                </Grid>
                            </Grid>
                            <Grid item container justify='flex-start' alignContent='flex-start' style={{ width: '62%' }}>
                                <Grid item>
                                    {activityName}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                )
            } catch (err) { }
        }


        const RenderCategoriesKeysComponent = ({ day }) => {
            try {
                const categoriesForToday = (this.state.categoriesUniqueArray && day === 0) ? this.state.categoriesUniqueArray.slice(0, 6) :
                    (this.state.categoriesUniqueArray && day === 1) ? this.state.categoriesUniqueArray.slice(6, 12) :
                        undefined;

                if (!categoriesForToday || (categoriesForToday && categoriesForToday.length === 0)) return (<Grid item container></Grid>)

                return (
                    <Grid item container >
                        <Grid item containr justify='center' alignContent='flex-start' style={{ padding: ' 0px 10px' }}>
                            <Grid item container>
                                <Grid item container justify='center'>
                                    <Grid item className='engageBlue  WeekViewKeyTitle'>Category Key</Grid>
                                </Grid>
                                {
                                    categoriesForToday.map(cat => {
                                        const catName = (cat.name && cat.name.length < 20) ? cat.name : cat.name.slice(0, 17) + '...'
                                        return (
                                            <Grid item container className='WeekViewKeyContent' >
                                                <Grid item container xs={3} justify='center' alignContent='flex-start'>
                                                    {
                                                        (cat && cat.svgString) ?
                                                            <Grid item style={{ height: '10px', width: '10px' }} >
                                                                <this.GetHTMLFromString str={cat.svgString} styleObjString={"style='height: 10px; width: 10px;'"} />
                                                            </Grid>
                                                            :
                                                            undefined
                                                    }
                                                </Grid>
                                                <Grid item xs={9} alignContent='flex-start' justify='center'>
                                                    <Grid item >
                                                        {catName}
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        )
                                    }
                                    )
                                }

                            </Grid>
                        </Grid>
                    </Grid>
                )
            } catch (err) { }


        }

        const RenderLocationsKeysComponent = ({ day }) => {

            const daysNeddedForLocations = (this.state.daysNeddedForLocationCodes) ? this.state.daysNeddedForLocationCodes : 1;

            let locationsForToday = undefined;
            if (daysNeddedForLocations === 1) {
                locationsForToday = (this.state.locationsUniqueArray && day === 6) ? this.state.locationsUniqueArray.slice(0, 6) : undefined;
            } else {
                locationsForToday = (this.state.locationsUniqueArray && day === 5) ? this.state.locationsUniqueArray.slice(0, 6) :
                    (this.state.locationsUniqueArray && day === 6) ? this.state.locationsUniqueArray.slice(6, 12) :
                        undefined;
            }

            if (!locationsForToday || locationsForToday.length === 0) return (<Grid item container></Grid>)

            return (
                <Grid item container justify='center' alignContent='flex-start' style={{ padding: ' 5px 10px' }}>
                    <Grid item container>
                        <Grid item container justify='center'>

                            <Grid item className='engageBlue WeekViewKeyTitle' >Location Key</Grid>
                        </Grid>
                        {
                            locationsForToday.map(location => {
                                const locationName = (location && location.name && location.name.length < 20) ? location.name : location.name.slice(0, 17) + '...'
                                return (
                                    <Grid item container className='WeekViewKeyContent'>
                                        <Grid item container xs={4} justify='center' alignContent='flex-start'>
                                            <Grid item className='activityTitleScheduleSpecialEvent' style={{ height: '10px', lineHeight: '12px', color: 'black' }}>
                                                {location.code.toUpperCase()}
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={8} className='dailyviewLocationStyles' alignContent='flex-start' justify='center'>
                                            <Grid item >
                                                {locationName}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                )
                            }


                            )
                        }

                    </Grid>
                </Grid>
            )
        }


        //#endregion

        return (
            <Grid container justify='center' >
                <Grid item container alignContent='flex-start' className='schedulerSize' id={this.props.idToSet ? this.props.idToSet : undefined}>
                    <RenderHeader />
                    <RenderDaysHeader />
                    <Grid style={{ position: 'relative', width: '100%', }}>
                        <RenderDateRow />
                    </Grid>
                    {/* <RenderActivitiesGrid /> */}
                    <RenderActivitiesColumComponent startDate={this.state.startDateWeek} endDate={this.state.endDateWeek} activitiesData={this.state.Activities} />
                    <RenderKeysComponentes startDate={this.state.startDateWeek} endDate={this.state.endDateWeek} activitiesData={this.state.Activities} />
                </Grid>
            </Grid>
        );
    };

}


function mapStateToProps(state) {

    let activitiesData = (state.activityReducer && state.activityReducer.calendarActivityData) ? state.activityReducer.calendarActivityData : [];
    activitiesData = activitiesData.sort((a, b) => {
        return (new moment(a.date) > new moment(b.date)) ? 1 : -1
    })

    return {

        activitiesData: activitiesData,
    };
};


export default connect(mapStateToProps, { getCommunityByIdAsync, GetAllActivities, GetActivityDetails, GetCalendarActivities, GetCategorieObject, GetMultipleCategorieObject })(SchedulerWeekView)